import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-payments-gateways-card',
  templateUrl: './payments-gateways-card.component.html',
  styleUrls: ['./payments-gateways-card.component.scss']
})
export class PaymentsGatewaysCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.spinnerService.show('payments-gateways-spinner');
  }

  ngAfterContentChecked() {
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('payments-gateways-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availablePaymentConfigs;
      this.disableCount = this.data.unavailablePaymentConfigs;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('payments-gateways-spinner');
    }
  }

}
